import { agent, API_MAP } from 'helpers';

class DeliveryProviderService {
  static listDeliveryProvider(newProduct?: boolean) {
    const param = newProduct === true ? 1 : 0;
    return agent.get(`${API_MAP.listDeliveryProviders}?new=${param}`);
  }
  static createBatch(id: any, pins: any) {
    return agent.post(`${API_MAP.createBatch}`.replace('{id}', id), { pins });
  }
  static uploadDeliveryProviderFile(files: any[], product: any, methodId: any) {
    return agent.post(`${API_MAP.uploadDeliveryProviders}`.replace('{id}', `${product}`), {
      deliveries: [{ files, method_id: methodId }],
    });
  }
  static uploadDeliveryProvider(params: any, product: any) {
    return agent.post(`${API_MAP.uploadDeliveryProviders}`.replace('{id}', `${product}`), { deliveries: params });
  }
}
export default DeliveryProviderService;
